<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.sector.name | translate }}- {{ editedEntity.department.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("common.create") }}</span>
      </h2>

      <filter-select
        id="sectorFilter"
        ref="sectorFilter"
        :placeholder="$t('sector.select')"
        :multiple="true"
        :isValid="!$v.form.sector.$invalid"
        @filter="onSectorSearch"
        :selected="form.sector"
        @changed="sectorSelect"
        track="_id"
      />

      <filter-select
        class="mt-4"
        id="departmentFilter"
        ref="departmentFilter"
        :placeholder="$t('department.select')"
        :multiple="true"
        :isValid="!$v.form.department.$invalid"
        @filter="onDepartmentSearch"
        :selected="form.department"
        @changed="departmentSelect"
        track="_id"
      />

      <br />
      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
const state = "sectorDepartment";

export default {
  props: ["state"],
  data() {
    return {
      form: { sector: undefined, department: undefined },
    };
  },
  validations: {
    form: {
      sector: {
        required,
      },
      department: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isWorkspaceLayout() {
      return this.state === "workspaceSectorDepartment";
    },
    isUpdating() {
      return this.$store.getters[`${this.state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${this.state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${this.state}/isEditMode`];
    },
  },
  async mounted() {
    this.state = this.state || state;
  },
  methods: {
    async save() {
      const sectors = this.form.sector;
      const childDepartments = this.form.department;
      this.$emit("onSave", sectors, childDepartments);
    },
    async onSectorSearch(value, callback) {
      const response = await this.$store.dispatch(`sector/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    sectorSelect(item) {
      this.form = { ...this.form, sector: item };
    },
    async onDepartmentSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceDepartment" : "managementDepartment";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: {
          name: { value },
          ...(!this.isWorkspaceLayout && { "scope.value": { value: "system", isObject: true } }),
        },
      });
      callback(response.data?.docs ?? []);
    },

    departmentSelect(item) {
      this.form = { ...this.form, department: item };
    },
  },
};
</script>
